const $ = require('jquery');

const config = {
  smartBannerURL: '#smartBannerURL',
  smartBannerIFrame: '#smartBannerIFrame',
};

class SmartBanner {
  constructor() {
    this.fallbackLink = '';
    this.timeout = null;
    this._preventPopup = this._preventPopup.bind(this);
  }
  _getUserAgent() {
    return navigator.userAgent;
  }

  _gotoStore() {
    let $bannerIFrame = $(config.smartBannerIFrame);
    if ($bannerIFrame.length) {
      $bannerIFrame.remove();
    }
    $('<iframe />')
      .attr('id', 'smartBannerIFrame')
      .attr('src', 'homedepot://homedepot.com')
      .attr('style', 'display:none;')
      .appendTo('body');

    this.timeout = setTimeout(() => {
      window.location.assign(this.fallbackLink);
    }, 25);

    window.addEventListener('pagehide', this._preventPopup);
  }

  _preventPopup() {
    clearTimeout(this.timeout);
    this.timeout = null;
    window.removeEventListener('pagehide', this._preventPopup);
  }

  init() {
    let navusr = this._getUserAgent();
    let isiOS =
      navusr.match('iPad') || navusr.match('iPhone') || navusr.match('iPod');
    let isAndroid = navusr.match('Android');
    this.fallbackLink = isAndroid
      ? 'market://details?id=com.thehomedepot'
      : 'itms-apps://itunes.apple.com/app/my-app/id342527639?mt=8';

    $(config.smartBannerURL).css('display', 'none');
    if (isiOS || isAndroid) {
      $(config.smartBannerURL).css('display', 'flex');
      $(config.smartBannerURL).on('click', (event) => {
        event.preventDefault();
        this._gotoStore();
      });
    }
  }
}

module.exports = new SmartBanner();
